<template>
  <router-view />
</template>

<script setup lang="ts">
import { useBase } from '@/composables/base';
import { useRequiredAuth } from '@/composables/required-auth';
import { useExceptionStore } from '@/stores/exception';
import { useDevice } from '@/composables/device';
import { useAuthenStore } from '@/stores/authen';
import { onBeforeUnmount, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useLang } from '@/composables/lang';
import { useTheme } from '@/composables/theme';
import { useAuth } from '@/composables/auth';
import { useHome } from '@/composables/home';
import { Cookies } from 'quasar';
import { AppAuthTokenKey } from '@/consts';
import { useReviewSocket } from '@/composables/review-socket';

const { appNavigateTo } = useBase();
const exceptionStore = useExceptionStore();
const router = useRouter();
const authenStore = useAuthenStore();
const { initialQuasarDark } = useTheme();
const { initialLocale } = useLang();
const { initialDevice } = useDevice();
const { checkLoginStatus } = useAuth();
const { connect } = useReviewSocket();

const { fetchDataGlobal } = useHome();
initialQuasarDark();
initialLocale();
useRequiredAuth();

const token = Cookies.get(AppAuthTokenKey);

onMounted(async () => {
  initialDevice();
  if (token) {
    await fetchDataGlobal();
  }
  if (
    exceptionStore.error &&
    exceptionStore.error.statusCode &&
    exceptionStore.error.message
  ) {
    appNavigateTo('/error', true);
  }
  window.onpopstate = () => {
    if (
      router.options.history.state.forward == '/auth/login' &&
      !authenStore.auth
    ) {
      window.history.forward();
    }
    // if (
    //   authenStore.auth !== undefined &&
    //   this.$route.path == '/login'
    // ) {
    //   this.$router.push('/');
    // }
    // if (authenStore.auth === undefined) {
    //   appNavigateTo('/auth/login', true);
    // }
  };
  await checkLoginStatus()
});

onBeforeUnmount(() => { });
</script>
